<dx-popup
  [visible]="visible"
  (onHiding)="close()"
  [fullScreen]="isMobile"
  [width]="isMobile ? '100vw' : 900"
  [height]="isMobile ? '100%' : '85vh'"
  [showTitle]="true"
  [title]="name || 'Uploaded file'"
  [showCloseButton]="true"
  [dragEnabled]="false"
  [wrapperAttr]="{ class: 'file-viewer-wrapper' }"
>
  <div class="fv" data-testid="file-viewer">
    <div class="fv__body">
      <img *ngIf="kind === 'image' && url" [src]="url" [alt]="name || 'Uploaded file'" class="fv__image" />
      <iframe *ngIf="kind === 'pdf' && frameUrl" [src]="frameUrl" class="fv__frame" [title]="name || 'Uploaded file'"></iframe>
      <p *ngIf="kind === 'other'" class="fv__note">This file type can't be shown here.</p>
    </div>
    <a *ngIf="url" [href]="url" target="_blank" rel="noopener" class="fv__open" data-testid="file-viewer-open-tab">Open in a new tab</a>
  </div>
</dx-popup>
